import React from "react";
import ListAgentsContainer from '../containers/ListAgents';
import Header from '../containers/Header';

function ListAgents() {

  return (
    <div>
      <Header />
      <ListAgentsContainer />
    </div>

  );
}

export default ListAgents;
